import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/cashComponent.vue' // 假设你有一个Home组件
import { getAppId } from '../util/appid.js'
/* eslint-disable */

const WXPAY_APP_ID = 'wx33818495adcf91e6'
const ALIPAY_APP_ID = ''

const router = createRouter({
    history: createWebHistory(window.location.origin),
    routes: [{
            path: '/',
            name: 'Home',
            component: Home,
        },
        // 其他路由...
    ],
})

router.beforeEach(async(to, from, next) => {
    const code = new URLSearchParams(window.location.search).get('code')
    const authCode = new URLSearchParams(window.location.search).get('auth_code')
    const state = new URLSearchParams(window.location.search).get('state')
    const cashPointId = new URLSearchParams(window.location.search).get('cp_id')
    getAppId()
  alert('code: ' + code)
  alert('state: ' + state)

    if (code && state) { // 微信授权
        try {
            const response = await fetch(`/stage-api/miniapp/logins/access_token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code, appid: WXPAY_APP_ID, platform: state }),
            })
            const data = await response.json()
            localStorage.setItem('appId', WXPAY_APP_ID)
            localStorage.setItem('uuid', data.uuid)
            next() // 继续导航
        } catch (error) {
            console.error('Error fetching openid:', error)
            next('/error') // 导航到错误页面
        }
    } else if (authCode) { // 支付宝授权
        try {
            const response = await fetch(`/api/miniapp/logins/access_token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ appid: ALIPAY_APP_ID, code: authCode, platform: state, cash_point_id: cashPointId }),
            })
            const data = await response.json()
            localStorage.setItem('appId', ALIPAY_APP_ID)
            localStorage.setItem('uuid', data.uuid)
            next() // 继续导航
        } catch (error) {
            console.error('Error fetching openid:', error)
            next('/error') // 导航到错误页面
        }
    } else {
        // 第一次路由跳转，第二次不会进入这里
        if (cashPointId) {
            localStorage.setItem('cashPointId', cashPointId) // 存储openid
        } else {
            localStorage.setItem('cashPointId', '')
        }

        const userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.match(/micromessenger/i)) {
            window.location.href = generateWechatAuthUrl()
        } else if (userAgent.match(/alipayclient/i)) {
            window.location.href = generateAlipayAuthUrl()
                // 支付宝浏览器
                // if (window.AlipayJSBridge) {
                //     alert('AlipayJSBridge')
                //     handleAlipayAuth();
                // } else {
                //     alert('AlipayJSBridgeReady')
                //     document.addEventListener('AlipayJSBridgeReady', handleAlipayAuth, false);
                // }
        } else {
            alert('请在微信或支付宝中打开') // 不是微信或支付宝浏览器，继续正常导航
        }
    }
})

function generateWechatAuthUrl() {
    const redirectUri = encodeURIComponent(window.location.origin)
    const state = 'wechat' // 使用state参数传递平台信息
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WXPAY_APP_ID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
}

function generateAlipayAuthUrl() {
    // 此处回调地址配置路径：支付宝开放平台=>开发设置=>授权回调地址
    const redirectUri = encodeURIComponent(window.location.origin)
    const state = 'alipay' // 使用state参数传递平台信息
    return `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${ALIPAY_APP_ID}&redirect_uri=${redirectUri}&state=${state}&scope=auth_base`
}

// 添加处理支付宝授权的函数
function handleAlipayAuth() {
    alert('handleAlipayAuth method')
    ap.getAuthCode({
            appId: ALIPAY_APP_ID,
            scopes: ['auth_user'],
            showErrorTip: true,
        })
        .then(res => {
            // alert('授权成功, res:');
            alert(JSON.stringify(res))
        })
        .catch(error => {
            alert(JSON.stringify(error))
        })
}
export default router
